import { useCallback, useContext } from "react";

import { MaskedInput } from "~/components/TextInput";
import { setCorporalEvaluationImageIndex } from "~/modules/corporalEvaluation/services";
import { patchEvaluationAtom } from "~/modules/evalutation/services";
import { studentEvaluationDemoContext } from "~/pages/authenticated/personalTrainer/studentEvaluationDemo";

import { Mean } from "./Mean";

export const SuprailiacInput: React.FC = () => {
	const { data } = useContext(studentEvaluationDemoContext);

	const handleUpdateField = useCallback(
		(index: number, value: number) => {
			const newArr = data ? data.suprailiac : [];
			newArr[index] = value;
			patchEvaluationAtom({ suprailiac: newArr });
		},
		[data],
	);

	const handleFocus = useCallback(() => {
		setCorporalEvaluationImageIndex(7);
	}, []);

	return (
		<>
			<div className="whitespace-nowrap font-bold xl:font-normal">
				Supra-Ilíaca (mm) &nbsp;
			</div>
			{data?.suprailiac.map((val, index) => (
				<div key={`suprailiac-${index}`}>
					<p className="block xl:hidden mb-2">Medida {index + 1}</p>
					<MaskedInput
						value={val}
						placeholder="0"
						mask="float"
						onFocus={handleFocus}
						inputMode="decimal"
						onChange={(v) => handleUpdateField(index, v)}
					/>
				</div>
			))}
			<div>
				<p className="block xl:hidden mb-2">Média</p>
				<Mean field="suprailiac" />
			</div>
		</>
	);
};
